module.exports = __webpack_public_path__ + "img/dataConfig.c886ee7e.svg";